// src/components/admin/AddAdmin.js
import React from "react";
import { useTranslation } from 'react-i18next';
import BackToDashboard from "../common/BackToAdminDashboard.js";  

const AddAdmin = () => {
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    alert(t("add_admin_success") || "Admin added!");
  };

  return (
    <div>
      <BackToDashboard dashboardPath="/admin/dashboard" />  

      <h1>{t("add_admin") || "Add Admin"}</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="username">{t("username_label") || "Username"}</label>
          <input type="text" id="username" name="username" required />
        </div>
        <div>
          <label htmlFor="email">{t("email_label") || "Email"}</label>
          <input type="email" id="email" name="email" required />
        </div>
        <div>
          <label htmlFor="password">{t("password_label") || "Password"}</label>
          <input type="password" id="password" name="password" required />
        </div>
        <div>
          <label htmlFor="confirmPassword">{t("confirm_password_label") || "Confirm Password"}</label>
          <input type="password" id="confirmPassword" name="confirmPassword" required />
        </div>
        <button type="submit">{t("add_admin") || "Add Admin"}</button>
      </form>
    </div>
  );
};

export default AddAdmin;
